








































import { isViewAsSelected } from "@/store/modules/TargetUserModule";
import { Component, Vue, Ref } from "vue-property-decorator";
import BaseDialogComponent from "@/components/common/BaseDialog.vue";
import { Mailbox } from "@/data/models/Mailbox";
import { generateRandomUuid } from "@/utils/Utils";
import MultiSelectionPickerComponent from "@/components/common/MultiSelectionPicker.vue";
import { findUser } from "@/data/repository/UserRepository";
import { getUserDisplayName } from "@/utils/UserUtils";
import { UserModule } from "@/store/modules/UserModule";
import {
  deleteMailbox,
  doesOtherMailboxWithNameExist,
  saveMailbox,
} from "@/data/repository/MailboxRepository";
import ConfirmationDialogComponent from "@/components/common/ConfirmationDialog.vue";

@Component({
  components: {
    "base-dialog": BaseDialogComponent,
    "multi-selection-picker": MultiSelectionPickerComponent,
    "confirmation-dialog": ConfirmationDialogComponent,
  },
})
export default class MailboxFormComponent extends Vue {
  isLoading = false;

  mailboxId = "";
  name = "";
  sortValue = "";

  showMessageToUserIds: string[] = [];
  collectMessagesFromUserIds: string[] = [];

  selectableUserIds: string[] = [];

  nameErrors: string[] = [];

  get userNameFormatter() {
    return (userId: string) => {
      const user = findUser(userId);
      return getUserDisplayName(user);
    };
  }

  @Ref("baseDialog")
  baseDialogComponent!: BaseDialogComponent;

  @Ref("confirmation")
  confirmationDialogComponent!: ConfirmationDialogComponent;

  resolve?: (value: Mailbox) => void = undefined;
  reject?: (reason: string) => void = undefined;

  async show(mailbox?: Mailbox) {
    this.nameErrors = [];

    if (mailbox) {
      this.mailboxId = mailbox.id;
      this.name = mailbox.name;
      this.showMessageToUserIds = mailbox.showMessageToUserIds;
      this.collectMessagesFromUserIds = mailbox.collectMessagesFromUserIds;
      this.sortValue = (mailbox.sortValue ?? 1).toString();
    } else {
      this.mailboxId = generateRandomUuid();
      this.name = "";
      this.sortValue = "1";
      this.showMessageToUserIds = [];
      this.collectMessagesFromUserIds = [];
    }

    this.selectableUserIds = UserModule.activeUsersOfClient.map(
      (user) => user.id
    );

    this.baseDialogComponent.show({
      title: this.$t("settings.mailbox.mailbox").toString(),
      // View only while "Sicht auf" is active (ticket 2610051).
      positiveButtonText: isViewAsSelected() ? null : this.$t("common.save").toString(),
      neutralButtonText: mailbox && !isViewAsSelected()
        ? this.$t("common.delete").toString()
        : undefined,
      closeOnNeutralAction: false,
      closeOnSave: false,
      persistent: true,
    });

    return new Promise<Mailbox>((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }

  async onDeleteMailbox() {
    const didConfirmDeletion = await this.confirmationDialogComponent.show({
      title: this.$t("settings.mailbox.confirmDeleteMailboxTitle").toString(),
      message: this.$t(
        "settings.mailbox.confirmDeleteMailboxMessage"
      ).toString(),
    });

    if (!didConfirmDeletion) {
      return;
    }

    await deleteMailbox(this.mailboxId);
    this.baseDialogComponent.isShowing = false;
  }

  async onSave() {
    this.isLoading = true;

    const mailbox: Mailbox = {
      id: this.mailboxId,
      name: this.name,
      sortValue: Number(this.sortValue),
      showMessageToUserIds: this.showMessageToUserIds,
      collectMessagesFromUserIds: this.collectMessagesFromUserIds,
    };

    const collidesWithOtherMailbox = await doesOtherMailboxWithNameExist(
      mailbox
    );

    if (collidesWithOtherMailbox) {
      this.nameErrors = [
        this.$t("settings.mailbox.errorNameAlreadyTaken").toString(),
      ];
      this.isLoading = false;
      return;
    }

    await saveMailbox(mailbox);

    this.isLoading = false;
    this.baseDialogComponent.isShowing = false;
    this.resolve && this.resolve(mailbox);
  }
}
